import { graphql, useStaticQuery } from 'gatsby';
export const useQueensAward = () => useStaticQuery(graphql `
      query useQueensAward {
        cosmos {
          pages {
            page: home(dataKey: "page") {
              queens_award {
                icon {
                  ticket
                  fileName
                }
                header
                copy
              }
            }
          }
        }
      }
    `).cosmos.pages;
export default useQueensAward;
